import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitFeedback = (payload) => api.post("/feedback", payload).then((r) => r.data);

export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then((r) => r.data);

export const fetchFeedback = (token) =>
  api
    .get("/admin/feedback", { headers: { "X-Admin-Password": token } })
    .then((r) => r.data);

export const fetchStats = (token) =>
  api
    .get("/admin/stats", { headers: { "X-Admin-Password": token } })
    .then((r) => r.data);

export const fetchTestimonials = () => api.get("/testimonials").then((r) => r.data);

export const downloadCsvUrl = () => `${API}/admin/feedback/csv`;
